import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "../../../../components/Page";
import Renovacion from "./Renovacion";
import { FetchRenovacionItem, validarModuloRenovacion } from "../../redux/aRenovaciones";
import ErrorPage from "../../../../components/ErrorPage";
import { RAMO_ENUM } from "../../constants/ramosEnums";

const ContainerRenovacionItem = ({ datosBancosCuotas, datosUsuario, location }) => {
  const [dataRenovacion, setDataRenovacion] = useState(null);
  const [allDataRenovacion, setAllDataRenovacion] = useState(null);
  const [loadingRenovacion, setLoadingRenovacion] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      const queryParams = new URLSearchParams(location.search);
      const idRenovacion = queryParams.get('id');

      try {
        const result = await FetchRenovacionItem(idRenovacion);

        console.log('resultresss', result);
        if (result && isMounted) {
          setDataRenovacion(result.dataRenovacion);
          setAllDataRenovacion(result.allDataRenovacion);
        }
      } catch (error) {
        console.error("Error cargando la renovación directamente:", error);
      }

      if (isMounted) setLoadingRenovacion(false);
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [location.search]);



  const getTitle = () => {
    if (!dataRenovacion) return 'Resumen Renovación';

    const ramoSeguro = dataRenovacion.ramo ||
      (dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamoProducto === 'PYMES' ? 'PYMES' : (dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamo)) || "";

    const ramoText = ramoSeguro === RAMO_ENUM.VEHICULOS ? 'Auto' :
      ramoSeguro === RAMO_ENUM.PYMES ? 'Pymes' : '';

    return `Resumen Renovación ${ramoText}`;
  };

  return (
    <main className="cr-app bg-light">
      <div className="cr-content container-fluid">
        <div className="container-body-spaces">
          <LoadingScreen
            loading={loadingRenovacion}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Obteniendo datos..."
          >
            <Page
              title={getTitle()}
              breadcrumbs={[{ name: "Renovación", active: true }]}
            >
              {datosUsuario && datosUsuario.dataUsuario && datosUsuario.dataUsuario.usu_tipo_usuario && validarModuloRenovacion(datosUsuario.dataUsuario.usu_tipo_usuario) ? (
                dataRenovacion && !loadingRenovacion ? (
                  <Renovacion
                    dataRenovacion={dataRenovacion}
                  />
                ) : null
              ) : (
                <ErrorPage mainText="No tienes permisos para acceder a esta funcionalidad" secondaryText="Por favor, contacta al administrador si crees que esto es un error" />
              )}
            </Page>
          </LoadingScreen>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  datosUsuario: state.datosUsuarios,
});

export default connect(mapStateToProps)(ContainerRenovacionItem);
